/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionOutput
 */
export interface VersionOutput {
    /**
     * 
     * @type {string}
     * @memberof VersionOutput
     */
    version?: string;
}

export function VersionOutputFromJSON(json: any): VersionOutput {
    return VersionOutputFromJSONTyped(json, false);
}

export function VersionOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function VersionOutputToJSON(value?: VersionOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
    };
}


